import { S3_IMG_BUCKET } from 'src/consts/user-web.const';

export const MAIN_BACKGROUND_1 = `${S3_IMG_BUCKET}MainBackground1.webp`;
export const MAIN_BACKGROUND_1_TEXT_IMAGE = `${S3_IMG_BUCKET}MainPageLogo.webp`;
export const MAIN_CONTENT = `${S3_IMG_BUCKET}MainContent.webp`;
export const MAIN_BACKGROUND_2 = `${S3_IMG_BUCKET}MainBackground2.webp`;
export const MAIN_CONTENT_TIME_TABLE = `${S3_IMG_BUCKET}MainContentTimeTable.webp`;
export const MAIN_ENTIRE_SCHEDULE = `${S3_IMG_BUCKET}MainEntireSchedule.webp`;
export const MAIN_CONCERT_INFO = `${S3_IMG_BUCKET}MainConcertInfo.webp`;

export const SCROLL_TOP_BUTTON = `${S3_IMG_BUCKET}ScrollTop.webp`;

export const PROGRAM_MAIN_BANNER = `${S3_IMG_BUCKET}MainProgramBanner.webp`;
export const PROGRAM_MAIN_DAY1 = `${S3_IMG_BUCKET}MainProgramDay1.webp`;
export const PROGRAM_MAIN_DAY2 = `${S3_IMG_BUCKET}MainProgramDay2.webp`;
export const PROGRAM_MAIN_DAY3 = `${S3_IMG_BUCKET}MainProgramDay3.webp`;
export const PROGRAM_CONTENT = `${S3_IMG_BUCKET}MainProgramContent.webp`;

export const CONCERT_INFO_BACKGROUND = `${S3_IMG_BUCKET}ConcertInfoBackground.webp`;
export const CONCERT_INFO1 = `${S3_IMG_BUCKET}ConcertInfo1.webp`;
export const CONCERT_INFO2 = `${S3_IMG_BUCKET}ConcertInfo2.webp`;
export const CONCERT_INFO3 = `${S3_IMG_BUCKET}ConcertInfo3.webp`;

export const MENU_MODAL1 = `${S3_IMG_BUCKET}MenuModal1.webp`;
export const MENU_MODAL2 = `${S3_IMG_BUCKET}MenuModal2.webp`;
export const MENU_BOARD1 = `${S3_IMG_BUCKET}MenuBoard1.webp`;
export const MENU_BOARD2 = `${S3_IMG_BUCKET}MenuBoard2.webp`;

export const SURVEY_MODAL = `${S3_IMG_BUCKET}SurveyModal.webp`;

export const CANCLE1 = `${S3_IMG_BUCKET}Cancle1.webp`;
export const CANCLE2 = `${S3_IMG_BUCKET}Cancle2.webp`;
export const CANCLE3 = `${S3_IMG_BUCKET}Cancle3.webp`;
export const FINAL_CANCLE = `${S3_IMG_BUCKET}FinalCancle.webp`;

export const SPECIAL_CONCERT = `${S3_IMG_BUCKET}SpecialConcert.webp`;
export const SPECIAL_CONCERT_INFO1 = `${S3_IMG_BUCKET}SpecialConcertInfo1.webp`;
export const SPECIAL_CONCERT_INFO2 = `${S3_IMG_BUCKET}SpecialConcertInfo2.webp`;
export const MOBILE_SPECIAL_CONCERT_INFO1 = `${S3_IMG_BUCKET}MobileSpecialConcertInfo1.webp`;
export const MOBILE_SPECIAL_CONCERT_INFO2 = `${S3_IMG_BUCKET}MobileSpecialConcertInfo2.webp`;
export const MOBILE_SPECIAL_CONCERT_INFO3 = `${S3_IMG_BUCKET}MobileSpecialConcertInfo3.webp`;

export const textImageModalData = [
  {
    id: 1,
    title: '1일차 라인업',
    summary: '개막콘서트 “희망드림”',
    thumbnail: `${S3_IMG_BUCKET}LineUp1.webp`,
  },
  {
    id: 2,
    title: '2일차 라인업',
    summary: '“오름향연”',
    thumbnail: `${S3_IMG_BUCKET}LineUp2.webp`,
  },
  {
    id: 3,
    title: '2일차 라인업',
    summary: '피날레 콘서트 “희망잔치”',
    thumbnail: `${S3_IMG_BUCKET}LineUp3.webp`,
  },
];

export const BUS_TIME_TABLE_DATA = {
  title: '축제 버스 시간표',
  summary: '2025 제주들불축제 버스 시간표 안내입니다.',
  thumbnail: `${S3_IMG_BUCKET}BusTimeTable.webp`,
  noticeIdList: [51, 52, 53],
};
